<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body"
  [style]="{'width': '90vw', 'height': '700px'}" [resizable]="false">

  <p-header>
    <span>Select Device</span>
  </p-header>

  <div style="overflow: hidden;">

    <!-- Search Box-->
    <div style="padding:4px 10px; border-bottom: 0 none">
      <i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
      <input type="text" pInputText size="50" placeholder="Filter" [(ngModel)]="searchText"
        (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      </div>

      <div style="height: 10px;">&nbsp;</div>

      <!-- Data table -->
      <uv-table #tt [value]="deviceEntries" [columns]="cols"
        [globalFilterFields]="['deviceName', 'ipAddress', 'macAddress', 'serialNumber', 'timeStamp', 'owner', 'network', 'agent', 'discovery']"
        [scrollable]="true" scrollHeight="500px" [resizableColumns]="true" dataKey="guid" selectionMode="single" [(selection)]="selectedEntry"
        [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">

        <ng-template pTemplate="header">
          <tr>
            <th uvResizableColumn>Device Name</th>
            <th uvResizableColumn>IP Address</th>
            <th uvResizableColumn>MAC Address</th>
            <th uvResizableColumn>Serial Number</th>
            <th uvResizableColumn>Timestamp</th>
            <th uvResizableColumn>Owner</th>
            <th uvResizableColumn>Network</th>
            <th uvResizableColumn>Agent</th>
            <th uvResizableColumn>Discovery</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr [style]="TableRowStyle" [uvSelectableRow]="rowData" (dblclick)="onDeviceSelected(rowData)" class="uv-table-row">
            <td title="{{ rowData.deviceName }}">
              <span class="uv-table-value">{{ rowData.deviceName }}</span>
            </td>
            <td title="{{ rowData.ipAddress }}">
              <span class="uv-table-value">{{ rowData.ipAddress }}</span>
            </td>
            <td title="{{ rowData.macAddress }}">
              <span class="uv-table-value">{{ rowData.macAddress }}</span>
            </td>
            <td title="{{ rowData.serialNumber }}">
              <span class="uv-table-value">{{ rowData.serialNumber }}</span>
            </td>
            <td title="{{ rowData.timeStamp }}">
              <span class="uv-table-value">{{ rowData.timeStamp }}</span>
            </td>
            <td title="{{ rowData.owner }}">
              <span class="uv-table-value">{{ rowData.owner }}</span>
            </td>
            <td title="{{ rowData.network }}">
              <a class="network-link" (click)="gotoNetwork(rowData.tag.scopeGuid)">
                <span class="uv-table-value">{{ rowData.network }}</span>
              </a>
            </td>
            <td title="{{ safeArrayJoin(rowData.agent) }}">
              @for (agent of rowData.agent; track agent; let i = $index) {
                <span>
                  <a class="agent-link" (click)="gotoAgent(rowData.tag.scopeGuid, rowData.tag.deviceObservations[i].agentGuid)">
                    <span class="uv-table-value">{{ agent }}</span>
                  </a>
                  @if (i < (rowData.agent.length - 1)) {
                    <span>, </span>
                  }
                </span>
              }
            </td>
            <td title="{{ rowData.discovery }}">
              @for (discovery of rowData.discovery; track discovery; let i = $index) {
                <span>
                  <a class="discovery-link" (click)="gotoDiscovery(rowData.tag.scopeGuid, 
                     rowData.tag.deviceObservations[i].agentGuid, 
                     rowData.tag.deviceObservations[i].schedDiscGuid)">
                    <span class="uv-table-value">{{ discovery }}</span>
                  </a>
                  @if (i < (rowData.discovery.length - 1)) {
                    <span>, </span>
                  }
                </span>
              }
            </td>
          </tr>
        </ng-template>
      </uv-table>

    </div>

    <p-footer>
      <button type="button" pButton icon="fa fa-check" [disabled]="!enableOkButton" (click)="onOkClicked()" label="OK"></button>
      <button type="button" pButton icon="fa fa-close" [disabled]="false" (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

  </p-dialog>
